import React from 'react';
import { AlertCircle, RefreshCcw } from 'lucide-react';

interface Props {
  message: string;
  onRetry?: () => void;
}

/** Inline error banner for failed list/detail loads. */
export const ErrorState: React.FC<Props> = ({ message, onRetry }) => (
  <div className="p-4 m-4 rounded-lg bg-red-50 dark:bg-red-950/40 border border-red-200 dark:border-red-900 flex items-start gap-3">
    <AlertCircle className="w-4 h-4 text-red-600 dark:text-red-400 mt-0.5 flex-shrink-0" />
    <div className="flex-1 min-w-0">
      <p className="text-sm font-semibold text-red-700 dark:text-red-300">Er ging iets mis</p>
      <p className="text-xs text-red-600 dark:text-red-400 mt-0.5">{message}</p>
    </div>
    {onRetry && (
      <button
        type="button"
        onClick={onRetry}
        className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md bg-white dark:bg-red-900/40 border border-red-200 dark:border-red-800 hover:bg-red-50 dark:hover:bg-red-900/60 text-xs font-semibold text-red-700 dark:text-red-300 transition-colors"
      >
        <RefreshCcw size={12} /> Opnieuw
      </button>
    )}
  </div>
);
